import { IPatient, PatientKindDisplayNames, PatientKind, WeightUnitOfMeasure } from "common/types";

type Patient = Pick<
  IPatient,
  "primary_breed" | "custom_breed" | "secondary_breeds" | "color" | "custom_color"
>;

export const primaryBreedDisplay = (patient: Patient) => {
  return patient.primary_breed?.label ?? patient.custom_breed;
};

export const secondaryBreedsDisplay = (patient: Patient) => {
  return patient.secondary_breeds.map((b) => b.label).join(", ");
};

export const colorDisplay = (patient: Patient) => {
  return patient.color?.label ?? patient.custom_color ?? "";
};

export const getWeightUnitOfMeasureLabel = (unit: WeightUnitOfMeasure | "" | null) => {
  const map: Record<WeightUnitOfMeasure, string> = {
    [WeightUnitOfMeasure.Gram]: "g",
    [WeightUnitOfMeasure.Kilogram]: "kg",
    [WeightUnitOfMeasure.Pound]: "lb",
    [WeightUnitOfMeasure.Ounce]: "oz",
  };
  return map[unit || WeightUnitOfMeasure.Pound];
};

export const getPatientKindDisplayName = (species: PatientKind): string => {
  return PatientKindDisplayNames[species] || "Unknown";
};
